import React from "react";
import { Table } from "@redriver/cinnamon";
import EditPrinter from "./EditPrinter";
import DeletePrinter from "./DeletePrinter";

const PrinterActions = ({ printer, dealerOfficeId, onRefresh }) => {
  return (
    <Table.Menu>
      <EditPrinter
        printer={printer}
        dealerOfficeId={dealerOfficeId}
        onSubmitted={onRefresh}
        as={Table.MenuItem}
      />
      <DeletePrinter
        printer={printer}
        onSubmitted={onRefresh}
        as={Table.MenuItem}
      />
    </Table.Menu>
  );
};

export default PrinterActions;
